import { Renderer2 } from '@angular/core';
import { AnimationService } from '../../core/ui/animation.service';
import { styleVariables } from '../../styles/variables';

export function animateHideSubscriptMessage(
  animation: AnimationService,
  renderer: Renderer2,
  el: HTMLElement
) {
  return animation
    .animate({
      targets: el,
      transform: 'translateY(-16px)',
      opacity: 0,
      duration: styleVariables.transitionDurationShort,
      easing: styleVariables.transitionCurveSharp,
    })
    .then(() => {
      renderer.setStyle(el, 'visibility', 'hidden');
      renderer.setStyle(el, 'opacity', 0);
    });
}

export function animateShowSubscriptMessage(
  animation: AnimationService,
  renderer: Renderer2,
  el: HTMLElement
) {
  renderer.setStyle(el, 'visibility', 'visible');
  renderer.setStyle(el, 'opacity', 0);
  return animation
    .animate({
      targets: el,
      transform: ['translateY(-16px)', 'translateY(0)'],
      opacity: [0, 1],
      duration: styleVariables.transitionDurationShort,
      easing: styleVariables.transitionCurveSharp,
    })
    .then(() => {
      renderer.setStyle(el, 'opacity', 1);
    });
}

export function animateSubscriptHostHeight(
  animation: AnimationService,
  renderer: Renderer2,
  el: HTMLElement,
  targetHeight: number
) {
  return animation
    .animate({
      targets: el,
      height: targetHeight,
      duration: styleVariables.transitionDurationShort,
      easing: styleVariables.transitionCurveSharp,
    })
    .then(() => {
      renderer.setStyle(el, 'height', `${targetHeight}px`);
    });
}

export function animateTopSubscriptMessage(
  animation: AnimationService,
  renderer: Renderer2,
  el: HTMLElement,
  start: number,
  end: number
) {
  renderer.setStyle(el, 'top', `${start}px`);
  return animation
    .animate({
      targets: el,
      top: [`${start}px`, `${end}px`],
      duration: styleVariables.transitionDurationShort,
      easing: styleVariables.transitionCurveSharp,
    })
    .then(() => {
      renderer.setStyle(el, 'top', `${end}px`);
    });
}
